import { responsiveModifierSet, isValidStyleProperty, isResponsiveModifier, getKey, stylePropertyValueAliases } from './swan-style.utils.js';
import { iterToSet } from './transform.utils.js';

function getClassName(key, value) {
  var modifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'xs';

  if (value === undefined || value === null) {
    return null;
  }

  var effectiveKey = getKey(key);
  if (!effectiveKey) return null;
  var prefix = "swan-".concat(effectiveKey);
  var suffix = modifier === 'xs' ? '' : "-".concat(modifier); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var finalValue = value;
  var aliasObj = stylePropertyValueAliases[key];

  if (aliasObj && (typeof value === 'string' || typeof value === 'number') && value in aliasObj && aliasObj[value] !== undefined) {
    finalValue = aliasObj[value];
  }

  switch (typeof finalValue) {
    case 'boolean':
      return finalValue ? prefix + suffix : null;

    default:
      return prefix + "-".concat(finalValue) + suffix;
  }
}

function updateClassNameSet(key, value, modifier, classNamesSet) {
  var cname = getClassName(key, value, modifier);

  if (cname) {
    classNamesSet.add(cname);
  }

  return classNamesSet;
}

function processResponsiveStyleProps(props, defaultResponsiveModifier) {
  var classNameSet = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();
  Object.keys(props).forEach(function (propKey) {
    if (!isValidStyleProperty(propKey)) {
      return null // exit iteration
      ;
    }

    if (typeof props[propKey] === 'object') {
      // Key must be a modifier
      var responsiveValue = props[propKey]; // eg: {xs: 1, md: 2}

      Object.keys(responsiveValue).forEach(function (modifier) {
        if (isResponsiveModifier(modifier)) {
          updateClassNameSet(propKey, responsiveValue[modifier], modifier, classNameSet);
        }
      });
    } else {
      updateClassNameSet(propKey, props[propKey], defaultResponsiveModifier, classNameSet);
    }
  });
  return classNameSet;
}

function processStyleProps(props, defaultClassNameSet) {
  var classNameSet = iterToSet(defaultClassNameSet);

  if (props.swanStyle) {
    var swanStyle = props.swanStyle;
    responsiveModifierSet.forEach(function (modifier) {
      var modifierValue = swanStyle[modifier];

      if (modifierValue) {
        classNameSet = processResponsiveStyleProps(modifierValue, modifier, classNameSet);
      }
    }); // This only process top level ResponsiveProps, inside Swan Style

    classNameSet = processResponsiveStyleProps(props.swanStyle, 'xs', classNameSet);
  } // This only process top level ResponsiveProps


  processResponsiveStyleProps(props, 'xs', classNameSet);
  return classNameSet;
}

export { processStyleProps };